import serializeParams from 'lib/utils/url';

export default (axios, payload) => axios.get(`/report/?${serializeParams(payload)}`);
